
import { defineComponent } from 'vue';
import Timer from './Timer.vue';

export default defineComponent({
  name: 'Form',
  emits: ['onSaveTask'],
  components: {
    Timer
  },
  data() {
    return {
      taskDescription: ''
    }
  },
  methods: {
    finishTask(elapsedTime: number): void {
      this.$emit('onSaveTask', {
        timeInSeconds: elapsedTime,
        description: this.taskDescription
      });
      this.taskDescription =  '';
    }
  }
});
